import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import projectAPI from 'api/ApiActions/Project/Project'

export const fetchProject: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('project/fetchProject', async ({ projectId }, { rejectWithValue }) => {
  try {
    const response = await projectAPI.fetch(projectId)
    return response?.data?.data
  } catch (error) {
    return rejectWithValue(error)
  }
})
